import { Modal } from '@eventbrite/eds-modal';
import React from 'react';
import { BoostBenefits } from '../../BoostBenefits';
import { BoostBenefitsProps } from '../../BoostBenefits/types';
import '../styles/upsellModal.scss';
import { BoostUpsellModalProps } from '../types';

export const BoostUpsellModal: React.FC<
    BoostUpsellModalProps & BoostBenefitsProps
> = ({ isOpen, onClose, ...benefitsProps }) => {
    return (
        <div className="boost-upsell-modal">
            <Modal isShown={isOpen} onClose={onClose ?? undefined} noPadding>
                <BoostBenefits {...benefitsProps} />
            </Modal>
        </div>
    );
};
